import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Dossier } from '../../shared/dossier/dossier';
import { PageTitle } from '../../shared/page-title/page-title';

// Dossier introuvable : route inconnue, operation en brouillon ou archivee.
@Component({
  selector: 'app-not-found-page',
  imports: [Dossier, PageTitle, RouterLink],
  templateUrl: './not-found-page.html',
})
export class NotFoundPage {}
